const RELEASE_TYPE = {
  CHANNEL: "Channel",
  PRODUCTION: "Production",
  CULTURE_HUB: "CultureHub",
};

const formatCount = (count) => String(count ?? 0).padStart(2, "0");

const countAttachmentsByReleaseType = (entries = [], releaseType) => {
  const attachmentIds = new Set();

  entries.forEach(({ attachmentId, releaseType: releaseTypes = [] }) => {
    if (releaseTypes.includes(releaseType)) {
      attachmentIds.add(attachmentId);
    }
  });

  return attachmentIds.size;
};

export const getReleaseDestinationLabel = ({
  channel = false,
  production = false,
  cultureHub = false,
} = {}) => {
  if (channel && production && cultureHub) {
    return "Canal, Produção e HUB Cultura";
  }

  if (channel && production) {
    return "Canal e Produção";
  }

  if (channel && cultureHub) {
    return "Canal e HUB Cultura";
  }

  if (production && cultureHub) {
    return "Produção e HUB Cultura";
  }

  if (channel) {
    return "Canal";
  }

  if (production) {
    return "Produção";
  }

  if (cultureHub) {
    return "HUB Cultura";
  }

  return "";
};

const getDestinationLabelFromReleaseTypes = (types) =>
  getReleaseDestinationLabel({
    channel: types.has(RELEASE_TYPE.CHANNEL),
    production: types.has(RELEASE_TYPE.PRODUCTION),
    cultureHub: types.has(RELEASE_TYPE.CULTURE_HUB),
  });

export const getSingleReleaseToastMessage = ({
  releases = [],
  unreleases = [],
  subject = "Anexo",
} = {}) => {
  const releasedTypes = new Set(
    releases.flatMap(({ releaseType = [] }) => releaseType)
  );

  const unreleasedTypes = new Set(
    unreleases.flatMap(({ releaseType = [] }) => releaseType)
  );

  const releasedDestination =
    getDestinationLabelFromReleaseTypes(releasedTypes);

  const unreleasedDestination =
    getDestinationLabelFromReleaseTypes(unreleasedTypes);

  if (releasedDestination && !unreleasedDestination) {
    return `${subject} liberado para ${releasedDestination}!`;
  }

  if (!releasedDestination && unreleasedDestination) {
    return `Liberação para ${unreleasedDestination} revogada!`;
  }

  return `Liberação do ${subject.toLowerCase()} atualizada com sucesso!`;
};

export const getBulkReleaseToastDescription = ({
  selectedCount,
  releases = [],
} = {}) => {
  const channelCount = countAttachmentsByReleaseType(
    releases,
    RELEASE_TYPE.CHANNEL
  );

  const productionCount = countAttachmentsByReleaseType(
    releases,
    RELEASE_TYPE.PRODUCTION
  );

  const cultureHubCount = countAttachmentsByReleaseType(
    releases,
    RELEASE_TYPE.CULTURE_HUB
  );

  const lines = [`Anexos selecionados: ${formatCount(selectedCount)}`];

  if (channelCount > 0) {
    lines.push(`Liberados para Canal: ${formatCount(channelCount)}`);
  }

  if (productionCount > 0) {
    lines.push(`Liberados para Produção: ${formatCount(productionCount)}`);
  }

  if (cultureHubCount > 0) {
    lines.push(`Liberados para HUB Cultura: ${formatCount(cultureHubCount)}`);
  }

  return lines.join("\n");
};
